@if (data.length > 0) {
  @for (group of data; track group.name) {
    <div *ngIf="group.layout === 'normal'"
         [ngStyle]="{
           'display': 'grid',
           'grid-template-columns': 'repeat(' + outterColumns + ', 1fr)',
           'gap': (outterRowGap ? outterRowGap.value + outterRowGap.unit : '0px') + ' ' +
                      (outterColumnGap ? outterColumnGap.value + outterColumnGap.unit : '0px')
         }">
      @for (item of group.items; track item.label) {
        <ng-container [ngTemplateOutlet]="contentTmpl" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
      }
    </div>
    <nz-collapse *ngIf="group.layout === 'collapse'" [nzBordered]="false" class="key-item-collapse">
      <nz-collapse-panel #p
                         [nzShowArrow]="false"
                         [nzActive]="group.dissabled || expand"
                         [nzDisabled]="group.dissabled"
                         [nzHeader]="groupNameTmpl">
        <div [ngStyle]="{
              'display': 'grid',
              'grid-template-columns': 'repeat(' + outterColumns + ', 1fr)',
              'gap': (outterRowGap ? outterRowGap.value + outterRowGap.unit : '0px') + ' ' +
                     (outterColumnGap ? outterColumnGap.value + outterColumnGap.unit : '0px')
              }">
          @for (item of group.items; track item.label) {
            <ng-container [ngTemplateOutlet]="contentTmpl"
                          [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
          }
          <ng-template #groupNameTmpl>
            <app-collapse-panel-header [panelActive]="p.nzActive"
                                       [onlyText]="group.name"
                                       [minHeight]="'0px'"
                                       [hideArrow]="!!group.dissabled"
            ></app-collapse-panel-header>
          </ng-template>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  }
} @else {
  <p>
    <app-st-icon name="cancel" [bold]="true" [filled]="true"></app-st-icon>
    No se tienen datos
  </p>
}

<!-- Contenido -->
<ng-template #contentTmpl let-item>
  <div class="flex"
       [ngStyle]="{
             'gap': innerColumnGap ? innerColumnGap.value + innerColumnGap.unit : null,
             'margin-bottom': innerRowGap ? innerRowGap.value + innerRowGap.unit : null,
             'max-width': pairMaxWidth ? pairMaxWidth.value + pairMaxWidth.unit : '425px',
           }"
  >
        <span *ngIf="!item.hideLabel"
              class="text-label-14"
              style="padding-top: 12px"
              [ngClass]="{'text-nowrap': item.noWrap}"
              [ngStyle]="keysWidth ? {'flex': '0 0 ' + keysWidth.value + keysWidth.unit} : null">
          {{ item.label }}:
        </span>

    <div *ngIf="isEditing(item) as editData"
         class="flex editable-wrapper"
         (keydown.tab)="tabPressed($event)"
         [class.editing]="editData.isEditingMode"
         [class]="item.type"
         [ngClass]="{'no-editable': !item.editable}" [class.hidden-label]="item.hideLabel"
         [style.max-width]="!!valuesMaxWidth ? valuesMaxWidth.value + valuesMaxWidth.unit : null"
         (click)="onItemClick(item, $event)">
      @switch (item.type) {

        @case ('text') {
          @if (!!item.numberValue) {
            <input nz-input type="number" [(ngModel)]="item.parentObject[item.path]"
                   [readOnly]="!item.editable || mockTabEvent"
                   [placeholder]="shouldShowPlaceholder(item) ? 'Vacío' : ''"
                   (blur)="checkBlurFocus(item, $event, item.parentObject[item.path])"
                   (focus)="checkBlurFocus(item, $event, item.parentObject[item.path])"
                   (keydown.enter)="saveChanges(item, item.path)">
          } @else {
            <textarea nz-input [(ngModel)]="item.parentObject[item.path]"
                      [readOnly]="!item.editable || mockTabEvent"
                      [placeholder]="shouldShowPlaceholder(item) ? 'Vacío' : ''"
                      (keydown.enter)="saveChanges(item, item.path)" [nzAutosize]="true"
                      (blur)="checkBlurFocus(item, $event, item.parentObject[item.path])"
                      (focus)="checkBlurFocus(item, $event, item.parentObject[item.path])"
            ></textarea>
          }
        }
        @case ('link') {
          <div class="flex" style="width: 100%; align-items: start">
            <textarea nz-input [(ngModel)]="item.parentObject[item.path]" autoWidth [extraWidth]="10"
                      [placeholder]="shouldShowPlaceholder(item) ? 'Vacío' : ''"
                      (keydown.enter)="saveChanges(item, item.path)" [nzAutosize]="true"
                      [readOnly]="!item.editable || mockTabEvent"
            ></textarea>
            <a [href]="item.value.url" target="_blank" *ngIf="!shouldShowPlaceholder(item)">
              <app-st-icon style="line-height: 1; padding-top: 4px;" name="open_in_new"></app-st-icon>
            </a>
          </div>
        }
        @case ('route') {
          <nz-select
            [nzAllowClear]="currentEditItem?.label === item.label && currentEditItem?.component === item.component"
            nzShowSearch
            class="key-value-select route-select"
            [class.double]="item.path && item.destinationPath"
            nzDropdownClassName="key-value-select"
            [(ngModel)]="item.parentObject[item.path]"
            [nzCustomTemplate]="customSelectTemplate"
            [nzShowArrow]="false"
            [nzPlaceHolder]="'Vacío'"
            [nzDropdownMatchSelectWidth]="false"
            [nzDropdownStyle]="{width: '200px'}"
            [nzDisabled]="!item.editable || mockTabEvent"
            nzBorderless
            [compareWith]="compareById"
            (ngModelChange)="onObjectToNumberSelectionChange($event, item)"
          >
            <!-- Template para el valor seleccionado -->
            <ng-template #customSelectTemplate let-selected>
              <div class="route-data">
                <app-st-icon [name]="selected.nzValue.locationTypeId | placeIcon"></app-st-icon>
                <span class="text-dark">{{ selected.nzValue.name }}</span>
              </div>
            </ng-template>

            <!-- Opciones del select -->
            <nz-option *ngFor="let item of item.list" [nzLabel]="item.name" [nzValue]="item" nzCustomContent>
              <div class="route-data text-nowrap">
                <app-st-icon [name]="item.locationTypeId | placeIcon"></app-st-icon>
                <span>{{ item.name }}</span>
              </div>
            </nz-option>
          </nz-select>

          @if (item.destinationPath) {
            <app-st-icon style="align-self: center; margin: 0 7px;" [bold]="true" name="arrow_forward"></app-st-icon>
            <nz-select
              [nzAllowClear]="currentEditItem?.label === item.label && currentEditItem?.component === item.component"
              class="key-value-select route-select"
              [class.double]="item.path && item.destinationPath"
              nzDropdownClassName="key-value-select"
              [(ngModel)]="item.parentObject[item.destinationPath]"
              nzShowSearch
              [nzCustomTemplate]="customSelectTemplate"
              [nzShowArrow]="false"
              [nzPlaceHolder]="'Vacío'"
              [nzDropdownMatchSelectWidth]="false"
              [nzDropdownStyle]="{width: '200px'}"
              nzBorderless
              [compareWith]="compareById"
              [nzDisabled]="!item.editable || mockTabEvent"
              (ngModelChange)="onObjectToNumberSelectionChange($event, item, true)"
            >
              <!-- Template para el valor seleccionado -->
              <ng-template #customSelectTemplate let-selected>
                <div class="route-data">
                  <app-st-icon [name]="selected.nzValue.locationTypeId | placeIcon"></app-st-icon>
                  <span class="text-dark">{{ selected.nzValue.name }}</span>
                </div>
              </ng-template>

              <!-- Opciones del select -->
              <nz-option *ngFor="let item of item.list" [nzLabel]="item.name" [nzValue]="item" nzCustomContent>
                <div class="route-data text-nowrap">
                  <app-st-icon [name]="item.locationTypeId | placeIcon"></app-st-icon>
                  <span>{{ item.name }}</span>
                </div>
              </nz-option>
            </nz-select>
          }
        }
        @case ('date') {
          <nz-date-picker [style.visibility]="item.value.showExpirationAlert ? 'hidden' : 'visible'"
                          [style.position]="item.value.showExpirationAlert ? 'absolute' : ''"
                          [(ngModel)]="item.parentObject[item.path]"
                          [nzSuffixIcon]="dateIconTmpl"
                          [nzAllowClear]="false"
                          [nzPlaceHolder]="'Vacío'"
                          [class.empty]="shouldShowPlaceholder(item)"
                          [nzShowTime]="item.value.showHours"
                          nzBorderless
                          [nzInputReadOnly]="!item.editable || mockTabEvent || !editData.isEditingMode"
                          class="key-value-date-picker"
                          [ngClass]="{'small-date': !item.value.format}"
                          [nzFormat]="item.value.format || 'd MMM y'"
                          [nzDisabled]="!item.editable || mockTabEvent"
                          (click)="onItemClick(item, $event)"
                          #datepicker
          ></nz-date-picker>

          <div *ngIf="item.value.showExpirationAlert" class="w-100" (click)="datepicker.open()">
            <div *ngIf="isExpirationAlert(item.parentObject[item.path]) as alertData"
                 class="st-badget flex-center-between"
                 [ngClass]="alertData.alertState ? (alertData.alertState === 'nearExp' ? 'expiration-badget' : 'expired-badget') : 'p-0'">
              <app-st-icon *ngIf="alertData.alertState"
                           style="height: 20px"
                           [color]="alertData.alertState === 'nearExp' ? '#A35200' : '#CB2A2F'"
                           [name]="'error'"
                           [bold]="true"></app-st-icon>
              <span class="text-dark">
                {{ item.parentObject[item.path] ? (item.parentObject[item.path] | date: 'd MMM yyyy - hh:mm a' | uppercase) : '-' }}
              </span>
            </div>
          </div>

          @if (item.endDatePath) {
            <app-st-icon style="align-self: center; margin: 0 7px;" [bold]="true" name="arrow_forward"></app-st-icon>
            <nz-date-picker [(ngModel)]="item.parentObject[item.endDatePath]"
                            [nzSuffixIcon]="dateIconTmpl"
                            [nzAllowClear]="false"
                            nzBorderless
                            [nzInputReadOnly]="!item.editable || mockTabEvent"
                            [nzPlaceHolder]="'Vacío'"
                            [class.empty]="shouldShowPlaceholder(item, item.endDatePath)"
                            class="key-value-date-picker"
                            [ngClass]="{'small-date': !item.value.format}"
                            [nzFormat]="item.value.format || 'd MMM y'"
                            [nzDisabled]="!item.editable || mockTabEvent"
                            (click)="onItemClick(item, $event)"
            ></nz-date-picker>
          }
          <ng-template #dateIconTmpl>
            <app-st-icon [color]="'#666666'" [bold]="true"
                         name="calendar_today"></app-st-icon>
          </ng-template>
        }
        @case ('badge') {
          <nz-select
            [nzAllowClear]="false"
            class="key-value-select badge-select"
            nzDropdownClassName="key-value-select"
            [(ngModel)]="item.parentObject[item.path]"
            [nzShowSearch]="true"
            [nzCustomTemplate]="customSelectTemplate"
            [nzPlaceHolder]="'Vacío'"
            [nzShowArrow]="false"
            [nzOptionHeightPx]="34"
            nzBorderless
            [nzDisabled]="!item.editable || mockTabEvent"
            [nzSize]="!!(isMobile$ | async) ? 'small' : 'default'"
          >
            <!-- Template para el valor seleccionado -->
            <ng-template #customSelectTemplate let-selected>
              <span *ngIf="selected.nzValue | projectState as stateData"
                    [class.small]="!!(isMobile$ | async)"
                    [ngClass]="stateData.class ? stateData.class : null" class="st-badget">
                <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
                <label>{{ stateData.name }}</label>
              </span>
            </ng-template>

            <!-- Opciones del select -->
            <nz-option *ngFor="let state of item.list" [nzValue]="state" nzCustomContent>
              <span *ngIf="state | projectState as stateData" [class.small]="!!(isMobile$ | async)"
                    [ngClass]="stateData.class ? stateData.class : null" class="st-badget text-nowrap">
                <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
                <label>{{ stateData.name }}</label>
              </span>
            </nz-option>
          </nz-select>
        }
        @case ('select') {
          <nz-select class="key-value-select"
                     [nzAllowClear]="currentEditItem?.label === item.label && currentEditItem?.component === item.component"
                     nzDropdownClassName="key-value-select"
                     [(ngModel)]="item.parentObject[item.path]"
                     [nzShowSearch]="true"
                     [nzPlaceHolder]="'Vacío'"
                     [nzShowArrow]="false"
                     [nzOptionHeightPx]="34"
                     nzBorderless
                     [nzDisabled]="!item.editable || mockTabEvent"
                     [nzSize]="!!(isMobile$ | async) ? 'small' : 'default'">
            <nz-option *ngFor="let option of item.list"
                       [nzLabel]="option[item.short]?
                              option[item.selectLabel]+' ('+option[item.short]+')':
                              option[item.selectLabel]"
                       [nzValue]="option[item.selectValue]">
            </nz-option>
          </nz-select>
        }
        @case ('avatar') {
          <nz-select
            [nzAllowClear]="currentEditItem?.label === item.label && currentEditItem?.component === item.component"
            class="key-value-select avatar-select"
            nzDropdownClassName="key-value-select"
            [(ngModel)]="item.parentObject[item.path]"
            (ngModelChange)="onObjectToNumberSelectionChange($event, item)"
            nzShowSearch
            [nzCustomTemplate]="customSelectTemplate"
            [nzShowArrow]="false"
            [nzPlaceHolder]="'Vacío'"
            [nzOptionHeightPx]="38"
            nzBorderless
            [nzDisabled]="!item.editable || mockTabEvent"
            [compareWith]="compareById"
          >
            <!-- Template para el valor seleccionado -->
            <ng-template #customSelectTemplate let-selected>
              <app-avatar-badge [entity]="selected?.nzValue"
                                [urlProperty]="item.value.isGood ? 'image' : 'avatar'"
                                [labelProperties]="item.value.isGood ? ['name'] : ['name', 'surName']"
              ></app-avatar-badge>
            </ng-template>

            <!-- Opciones del select -->
            @if (!item.value.isGood) {
              <nz-option *ngFor="let item of item.list"
                         [nzLabel]="item.name + (item.surName ? ' ' + item.surName : '')" [nzValue]="item"
                         nzCustomContent>
                <app-avatar-badge [entity]="item" [urlProperty]="'image'"
                                  [labelProperties]="['name']"></app-avatar-badge>
              </nz-option>
            } @else {
              <nz-option *ngFor="let item of item.list"
                         [nzLabel]="item.name" [nzValue]="item" nzCustomContent>
                <app-avatar-badge [entity]="item"
                                  [urlProperty]="'avatar'"
                                  [labelProperties]="['name', 'surName']"></app-avatar-badge>
              </nz-option>
            }
          </nz-select>
        }
        @case ('btn') {
          <button class="doc-btn max-w-100" nz-button nzSize="small" nzType="default"
                  (click)="!shouldShowPlaceholder(item) && (item.value.isOdoo ? openOdoo(item.value.link) : openLink(item.parentObject, item, $event))"
                  [ngClass]="{'empty': shouldShowPlaceholder(item)}">

            <img *ngIf="item.value.localPrefix && !shouldShowPlaceholder(item)"
                 alt="preffix" [src]="'assets/icons/' + item.value.localPrefix">

            <app-st-icon *ngIf="item.value.prefix && !shouldShowPlaceholder(item)"
                         [bold]="true" [name]="item.value.prefix"></app-st-icon>

            <input nzBorderless class="key-value-btn-input cursor-pointer" type="text" nz-input autoWidth
                   [placeholder]="shouldShowPlaceholder(item) ? 'Vacío' : ''" [readOnly]="!item.editable || mockTabEvent"
                   [(ngModel)]="item.parentObject[item.path]">

            <app-st-icon class="link-btn" *ngIf="!shouldShowPlaceholder(item)" [bold]="true"
                         [name]="item.value.sufix"></app-st-icon>
          </button>
        }
        @case ('boolean') {
          <nz-select class="key-value-select"
                     [nzAllowClear]="currentEditItem?.label === item.label && currentEditItem?.component === item.component"
                     nzDropdownClassName="key-value-select"
                     [(ngModel)]="item.parentObject[item.path]"
                     [nzShowSearch]="true"
                     [nzPlaceHolder]="'Vacío'"
                     [nzShowArrow]="false"
                     [nzOptionHeightPx]="34"
                     [nzCustomTemplate]="cstTmpl"
                     nzBorderless
                     [nzDisabled]="!item.editable || mockTabEvent"
                     [nzSize]="!!(isMobile$ | async) ? 'small' : 'default'">
            <nz-option *ngFor="let option of [true, false]"
                       [nzLabel]="option ? 'Si' : 'No'" [nzValue]="option">
            </nz-option>
          </nz-select>
          <ng-template #cstTmpl>
            <div class="flex-center gap-100 ">
              <app-st-icon *ngIf="item.icon" [color]="item.parentObject[item.path] ? item.trueColor : item.falseColor"
                           [name]="item.icon"></app-st-icon>
              <span class="text-label-14 text-dark">{{ item.parentObject[item.path] ? 'Si' : 'No' }}</span>
            </div>
          </ng-template>
        }
        @case('money') {
          @if (item.value.number) {
            <span class="text-label-14 text-dark" style="line-height: 1.8">{{item.value.number | number: '1.0-4'}} {{item.value.iso}}</span>
          } @else {
            -
          }
        }
        @default {
          <p>No tenemos definido este tipo de 'key-value' item.</p>
        }
      }
    </div>

    <div *ngIf="currentEditItem && currentEditItem.label !== item.label" class="blocker-element"></div>
  </div>
</ng-template>
